module.exports = __webpack_public_path__ + "img/597276e.svg";